module.exports = __webpack_public_path__ + "static/img/performance01.dd7e4477.jpg";